import api from './api';

export const excelExportService = {
  async exportSamples(params?: {
    storageRoomId?: number;
    startDate?: string;
    endDate?: string;
    includeUsageRecords?: boolean;
    adminViewAll?: boolean;
    sampleIds?: number[]; // 選択したサンプルIDの配列
  }): Promise<Blob> {
    const queryParams = {
      storageRoomId: params?.storageRoomId,
      startDate: params?.startDate,
      endDate: params?.endDate,
      includeUsageRecords: params?.includeUsageRecords,
      adminViewAll: params?.adminViewAll ? 'true' : undefined,
    };
    // sampleIdsが指定されている場合はPOST、それ以外はGET
    if (params?.sampleIds && params.sampleIds.length > 0) {
      const response = await api.post(
        '/excel-export/samples',
        { sampleIds: params.sampleIds },
        {
          params: queryParams,
          responseType: 'blob',
        }
      );
      return response.data;
    } else {
      const response = await api.get('/excel-export/samples', {
        params: queryParams,
        responseType: 'blob',
      });
      return response.data;
    }
  },
};

